import type { GameId, GameProfile } from '../types';
import { ball6 } from './ball6';
import { ball12 } from './ball12';
import { ball24 } from './ball24';
import { ball48 } from './ball48';
import { roulette } from './roulette';
import { sicbo } from './sicbo';

export { ball6, ball12, ball24, ball48, roulette, sicbo };

export const PROFILES: Record<GameId, GameProfile> = {
  'ball-6': ball6,
  'ball-12': ball12,
  'ball-24': ball24,
  'ball-48': ball48,
  roulette,
  sicbo,
};

export function resolveProfile(game: GameId | GameProfile): GameProfile {
  if (typeof game === 'string') {
    const profile = PROFILES[game];
    if (!profile) {
      throw new Error(`Unknown game id: ${game}. Valid: ${Object.keys(PROFILES).join(', ')}`);
    }
    return profile;
  }
  return game;
}
